import { createSlice } from "@reduxjs/toolkit";
import { getAllowedManageTeamTabs } from "../../guard/menuUtils";
import { pushDynamicTab } from "../utils/dynamicTabs";
const SLICE_VERSION = "1.0";

const allTabs = [
  { id: "teamMembers", name: "Team Members" },
  { id: "org-invites", name: "Organization Invites" },
  { id: "pref-partners", name: "Preferred Partners" },
  { id: "child-org", name: "Office Management" },
  { id: "role-mgmt", name: "Role Management" },
  { id: "location-mgmt", name: "Location Management" },
];

// Get filtered tabs immediately when slice loads
const getInitialTabs = () => {
  const allowedTabs = getAllowedManageTeamTabs("manageTeam");
  return allowedTabs.length > 0
      ? allTabs.filter(tab => allowedTabs.includes(tab.name))
      : allTabs; // Fallback to all tabs if no permissions yet
};

export const initialState = {
  _version: SLICE_VERSION,
  // Filter default tabs by permission when available; fall back to all tabs if nothing is cached yet.
  defaultTabs: getInitialTabs(),
  dynamicTabs: [],
  activeTab: 0,
};

const manageTeamSlice = createSlice({
  name: "manageTeam",
  initialState,
  reducers: {
    addTab: (state, action) => {
      const tab = {
        ...action.payload,
        createdAt: action.payload?.createdAt ?? Date.now(),
      };
      pushDynamicTab(state, tab, state.defaultTabs.length);
    },
    removeTab: (state, action) => {
      const { tabIndex, defaultTabsCount } = action.payload;
      const dynamicIndex = tabIndex - defaultTabsCount;
      if (dynamicIndex < 0) return;
      state.dynamicTabs.splice(dynamicIndex, 1);
      const totalTabs = state.defaultTabs.length + state.dynamicTabs.length;
      state.activeTab =
          state.activeTab === tabIndex
              ? Math.max(0, Math.min(tabIndex - 1, totalTabs - 1))
              : Math.min(state.activeTab > tabIndex ? state.activeTab - 1 : state.activeTab, totalTabs - 1);
      // state.activeTab = Math.min(
      //     state.activeTab,
      //     state.defaultTabs.length + state.dynamicTabs.length - 1
      // );
    },
    setActiveTab: (state, action) => {
      const { index } = action.payload;
      if (index >= 0 && index < state.defaultTabs.length + state.dynamicTabs.length) {
        state.activeTab = index;
      }
    },
    resetTabs: (state) => {
      state.dynamicTabs = [];
      state.activeTab = 0;
    },
  },
});

export const { addTab, removeTab, setActiveTab, resetTabs } = manageTeamSlice.actions;
export default manageTeamSlice.reducer;
